import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  DateTimeFilter,
  GroupedSearchFilterFacet,
  QueryableFilter,
  SearchFilterFacet,
} from '@savgroup-front-common/types';

import { BulkActionType } from './bulkActions.types';

const ENDPOINT = `${APIConfiguration.search}bulkActions/byFilters`;

export interface SearchQueryWithoutPagination {
  query?: string;
  groupedFilters?: GroupedSearchFilterFacet[];
  filters?: SearchFilterFacet[];
  numericFilters?: unknown;
  dateTimeFilters?: DateTimeFilter[];
  queryableFilters?: QueryableFilter[];
}

export interface CreateBulkActionJobByFiltersArgs {
  itemFilters: SearchQueryWithoutPagination;
  actionType: BulkActionType;
  actionParameters?: unknown;
  tenantId?: string;
  sellerId?: string;
}

async function createBulkActionJobByFiltersCommand({
  itemFilters,
  actionType,
  actionParameters,
  tenantId,
  sellerId,
}: CreateBulkActionJobByFiltersArgs): Promise<
  BackResponse<string> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<string>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        itemFilters,
        actionType,
        actionParameters,
        tenantId,
        sellerId,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default createBulkActionJobByFiltersCommand;
